<form #form="ngForm" novalidade class="usuario-acessos">
    <div class="row">
        <div class="col-12">
            <div class="alert alert-warning" role="alert">
                <p class="mb-0"><i class="fas fa-lock"></i> Recursos que possuem acesso restrito.</p>
                <p class="mb-0"><strong>Selecione apenas os recursos que este usuário deve possuir acesso.</strong></p>
            </div>
        </div>
    </div>
    

    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Recursos
            </h6>
        </div>        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <ng-template [ngIf]="isPerfilAdminitrador">
                <!-- Configurações -->
                 <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.acessoConfiguracoes" name="acessoConfiguracoes" id="acessoConfiguracoes">
                        <label class="custom-control-label" for="acessoConfiguracoes">Configurações</label>
                    </div>
                    <p class="form-text text-muted">Selecione esta opção para permitir este usuário acessar as configurações da plataforma</p>
                </li> 
                <!-- Admin -->
                <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.acessoUsuarios" name="acessoUsuarios" id="acessoUsuarios">
                        <label class="custom-control-label" for="acessoUsuarios">Usuários</label>
                    </div>
                    <p class="form-text text-muted">Selecione esta opção para permitir este usuário à cadastrar e gerenciar usuários</p>
                </li> 
            </ng-template>

            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.acessoProspeccaoOutbound" name="acessoProspeccaoOutbound" id="acessoProspeccaoOutbound">
                    <label class="custom-control-label" for="acessoProspeccaoOutbound">Prospecção Outbound</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir este usuário à prospectar novos prospects e leads através da Prospecção Outbound</p>
            </li>            
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.acessoComissoes" name="acessoComissoes" id="acessoComissoes">
                    <label class="custom-control-label" for="acessoComissoes">Comissões</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir este usuário consultar as comissões</p>
            </li>

            <li class="list-group-item" *ngIf="!isPerfilRepresentante">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.acessoTabelasPrecos" name="acessoTabelasPrecos" id="acessoTabelasPrecos">
                    <label class="custom-control-label" for="acessoTabelasPrecos">Tabelas de Preços</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir este usuário à cadastrar e gerenciar tabelas de preços</p>
            </li>                                   
        </ul>
    </div>
</form>
